var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0Z",
    fill: "#52CC8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6816 5.29255C11.9219 5.53287 11.9219 5.92251 11.6816 6.16283L6.98311 10.8613C6.8677 10.9767 6.71117 11.0416 6.54796 11.0416C6.38475 11.0416 6.22823 10.9767 6.11282 10.8613L4.09919 8.84768C3.85886 8.60735 3.85886 8.21771 4.09919 7.97739C4.33951 7.73707 4.72915 7.73707 4.96947 7.97739L6.54796 9.55588L10.8113 5.29255C11.0516 5.05222 11.4413 5.05222 11.6816 5.29255Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.294f17203f014c0a38d921fdfd16213f.svg";
export { ForwardRef as ReactComponent };